// Nuevo servicio para búsqueda de productos por código
import { ApiRequestInterceptorQS } from "./apiRequestQS";
import { ALMACEN } from "../Constants/Endpoinst";

const BUSQUEDA_PRODUCTO_ENDPOINT = ALMACEN.almacen_id;

export const buscarProductoPorCodigo = async (codigo) => {
    const urlConQuery = `${BUSQUEDA_PRODUCTO_ENDPOINT}?q=${encodeURIComponent(codigo)}`;
    const { code, data } = await ApiRequestInterceptorQS(urlConQuery, "GET");

    return { code, data };
};
